import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_safety_measures_in_place_regarding_asbestos_s'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_safety_measures_in_place_regarding_asbestos_s',
  name: 'Does the facility have safety measures in place regarding asbestos?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FACILITY_HAS_PERFORMED_AN_ASBESTOS_EXPOSURE_ASSESSMENT',
      text: 'Facility has performed an asbestos exposure assessment',
      externalIds: [
        {
          id: 'hs-14-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_HAS_TAKEN_THE_PROPER_STEPS_TO_ENSURE_THAT_WORKERS_ARE_',
      text: 'Facility has taken the proper steps to ensure that workers are not exposed to asbestos',
      externalIds: [
        {
          id: 'hs-14-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MATERIALS_CONTAINING_ASBESTOS_ASBESTOS_EXPOSURE_AREAS_ARE_LABEL',
      text: 'Materials containing asbestos/asbestos exposure areas are labeled as such',
      externalIds: [
        {
          id: 'hs-14-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-14-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FACILITY_HAS_PERFORMED_AN_ASBESTOS_EXPOSURE_ASSESSMENT',
                'FACILITY_HAS_TAKEN_THE_PROPER_STEPS_TO_ENSURE_THAT_WORKERS_ARE_',
                'MATERIALS_CONTAINING_ASBESTOS_ASBESTOS_EXPOSURE_AREAS_ARE_LABEL',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-bui-14',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14170,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
